import { theme, extendTheme } from "@chakra-ui/react";
import { createBreakpoints } from "@chakra-ui/theme-tools"
import { get } from "lodash";

const bp = [0, 30, 48.25, 62, 80, 96].map(em => em * 16);

const chakraBpNames = ['sm', 'md', 'lg', 'xl', '2xl']
export const breakpoints = chakraBpNames.reduce((bps, name, i) => {
  bps[name] = `${bp[i + 1]}px`
  return bps
}, {})

const font = '"Crimson Text", "Noto Sans TC", Arial, "PingFang TC", "HeiTi TC", "Microsoft JhengHei", sans-serif';
const fonts = {
  heading: font,
  body: font,
  mono: "Menlo, monospace",
}

const primary = 'blue'
const secondary = 'green'
const danger = 'red'

const overrides = {
  fonts,
  colors: {
    ...theme.colors,
    primary: get(theme.colors, `${primary}.500`),
    secondary: get(theme.colors, `${secondary}.500`),
    danger: get(theme.colors, `${danger}.500`),
    text: get(theme.colors, 'black'),
    custom: {
      lightGray: '#c9c9c9',
      gray: '#666666',
      text: '#333333',
      titleBlack: '#211815',
      blue: '#0075bb',
      skyBlue: '#E9EFF6',
      tabBg: '#CBDCEB',
      tabColor: '#9BB3C4',
      oceanBlue: '#306DAF',
      equipBlue: '#0070B4',
      surveyBlue: '#6B9DBF',
      prepareBlue: '#E3EBF2',
      finishYellow: '#EFCA7E',
      aboutBg: '#D9E5F1',
      divideBlue: '#CBD4DF',
      waveBlue: '#005B93',
      disabledBlue: '#085998',
    }
  },
  breakpoints: createBreakpoints(breakpoints),
  components: {
    Button: {
      defaultProps: {
        colorScheme: 'blue',
      },
    },
    Container: {
      baseStyle: {
        maxW: 'container.lg',
      },
    },
  },
}

const customTheme = extendTheme(overrides)

export default customTheme
